<template>
  <div class="general-table-user-site">
    <b-card class="table-shell">
      <div
        v-if="!isRequestTable"
        class="table-toolbar"
      >
        <div class="toolbar-grid">
          <div class="toolbar-head">
            <div class="toolbar-title">
              <div class="toolbar-icon">
                <feather-icon
                  icon="SearchIcon"
                  size="16"
                  class="text-white"
                />
              </div>
              <div class="ml-1">
                <div class="toolbar-heading">
                  Search & manage
                </div>
                <div class="toolbar-subtitle">
                  Find users fast, filter results, then export to Excel.
                </div>
              </div>
            </div>

            <div
              v-if="!dataLoad"
              class="toolbar-actions"
            >
              <b-button
                v-if="filterUserSite"
                variant="outline-primary"
                class="toolbar-btn"
                @click="showFilters = !showFilters"
              >
                <feather-icon
                  :icon="showFilters ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                  size="16"
                  class="mr-50"
                />
                Filters
              </b-button>

              <b-button
                v-if="addType.length"
                ref="actions"
                variant="primary"
                class="toolbar-btn toolbar-primary"
                @click="goToPageOrOpenModal()"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="16"
                  class="mr-50"
                />
                <span class="text-nowrap">{{ addType }}</span>
              </b-button>

              <b-button
                v-if="addUrlLink.length"
                ref="actions"
                variant="primary"
                class="toolbar-btn toolbar-primary"
              >
                <a
                  :href="addUrlLink"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-nowrap text-white"
                >
                  <feather-icon
                    icon="ExternalLinkIcon"
                    size="16"
                    class="mr-50"
                  />
                  {{ addComponentName }}
                </a>
              </b-button>

              <div>
                <IndexExecl
                  :need-excel="needExcel"
                  :need-payroll-excel="needPayrollExcel"
                  :need-user-excel="needUserExcel"
                  :skip-page="skipPage"
                />
              </div>
            </div>
          </div>

          <div class="toolbar-search-row">
            <SearchInputActionUserSite
              v-if="normalSearch && !dataLoad"
              :data-load="dataLoad"
              :view-search-input="viewSearchInput"
              :get-all-data="getAllData"
            />
          </div>
        </div>
      </div>

      <b-collapse
        v-if="filterUserSite && !dataLoad"
        v-model="showFilters"
        class="filters-collapse"
      >
        <div class="filters-card">
          <div class="filters-steps">
            <div class="filters-step">
              <div class="step-dot">
                1
              </div>
              <div class="step-text">
                Choose filters
              </div>
            </div>
            <div class="filters-step">
              <div class="step-dot">
                2
              </div>
              <div class="step-text">
                Apply results
              </div>
            </div>
            <div class="filters-step">
              <div class="step-dot">
                3
              </div>
              <div class="step-text">
                Export to Excel
              </div>
            </div>
          </div>

          <FilterUserUserSite
            :data-load="dataLoad"
            :get-all-data="getAllData"
          />
        </div>
      </b-collapse>

      <b-row>
        <b-col md="12">
          <div
            v-if="dataLoad"
            class="text-center my-2"
          >
            <b-spinner
              type="grow"
              label="Loading..."
            />
          </div>

          <b-table
            v-else
            ref="generalTable"
            :key="tableDataKey"
            :items="rows"
            :fields="columns"
            :per-page="perPage"
            aria-busy="true"
            class="position-relative table-main"
            responsive
            show-empty
            bordered
            sticky-header
            primary-key="id"
            :no-local-sorting="true"
            @row-clicked="handleRowClick"
          >
            <template
              v-for="(_, slotName) of $scopedSlots"
              v-slot:[slotName]="scope"
            >
              <slot
                :name="slotName"
                v-bind="scope"
              />
            </template>

            <template #thead-top>
              <tr>
                <th
                  v-for="(topHead, index) in topHeader"
                  :key="index"
                  :colspan="topHead.colspan"
                  class="main-header-table"
                >
                  {{ topHead.lable }}
                </th>
              </tr>
              <tr />
            </template>

            <template #cell(actions)="data">
              <slot
                name="actions"
                v-bind="data"
              >
                <div class="space-icons">
                  <PostEntryAction
                    v-if="postContent"
                    :data="data"
                    :get-all-data="getAllData"
                    :api-url="apiUrl"
                  />

                  <PostContentAction
                    v-if="postContent"
                    :data="data"
                  />

                  <ViewContentAction
                    v-if="viewContent"
                    :data="data"
                    :viw-component="viwComponent"
                  />

                  <EditContentAction
                    v-if="editContent"
                    :edit-component="editComponent"
                    :data="data"
                    :type="type"
                  />

                  <DeleteContentAction
                    v-if="deleteContent"
                    :data="data"
                    :api-url="apiUrl"
                    :get-all-data="getAllData"
                  />

                  <CancelContentAction
                    v-if="cancelContent"
                    :data="data"
                    :api-url="apiUrl"
                    :get-all-data="getAllData"
                  />
                </div>
              </slot>
            </template>

            <template #cell(name)="data">
              <span style="font-size: smaller; text-wrap: nowrap">
                {{ data.item.name }}
              </span>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <div class="mx-2 mb-2">
        <Pagination
          v-if="!haveRequests"
          :page="page"
          :per-page="perPage"
          :total-rows="totalRows"
          @get-all-data="getAllData"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import GeneralTable from './GeneralTable.vue'
import SearchInputActionUserSite from './actions/SearchInputActionUserSite.vue'
import FilterUserUserSite from './filter-by/FilterUserUserSite.vue'

export default {
  name: 'GeneralTableUserSite',
  components: {
    SearchInputActionUserSite,
    FilterUserUserSite,
  },
  extends: GeneralTable,
  data() {
    return {
      showFilters: false,
    }
  },
}
</script>
